export const blockIconsTransportationRvHookupNew = (
	<span className='material-symbols-outlined'>rv_hookup</span>
);
